module.exports = __webpack_public_path__ + "img/logo2.a2d2dbb8.png";